import FloatingBtn from './floating-btn';

export default FloatingBtn;